/**
 * PF2e (remaster) attribute modifiers and boosts.
 * A boost gives +1 to a modifier below +4. At +4 or higher a boost is "partial":
 * two partial boosts to the same attribute make +1.
 */
export type Attribute = 'str' | 'dex' | 'con' | 'int' | 'wis' | 'cha';
export const ATTRIBUTES: readonly Attribute[] = ['str', 'dex', 'con', 'int', 'wis', 'cha'];
export const ATTRIBUTE_NAMES: Record<Attribute, string> = {
  str: 'Strength', dex: 'Dexterity', con: 'Constitution', int: 'Intelligence', wis: 'Wisdom', cha: 'Charisma',
};

export type Attributes = Record<Attribute, number>;

export function emptyAttributes(): Attributes {
  return { str: 0, dex: 0, con: 0, int: 0, wis: 0, cha: 0 };
}

export function isPartialBoost(attrs: Attributes, attr: Attribute): boolean {
  return attrs[attr] >= 4;
}

/** Applies one boost in place. Returns whether the modifier rose or a partial boost was banked. */
export function applyBoost(attrs: Attributes, partials: Attribute[], attr: Attribute): 'increased' | 'partial' {
  if (attrs[attr] < 4) {
    attrs[attr] += 1;
    return 'increased';
  }
  const i = partials.indexOf(attr);
  if (i >= 0) {
    partials.splice(i, 1);
    attrs[attr] += 1;
    return 'increased';
  }
  partials.push(attr);
  return 'partial';
}
